import { render, staticRenderFns } from "./GameAnalyticsModal.vue?vue&type=template&id=0770c67b&scoped=true"
import script from "./GameAnalyticsModal.vue?vue&type=script&lang=js"
export * from "./GameAnalyticsModal.vue?vue&type=script&lang=js"
import style0 from "./GameAnalyticsModal.vue?vue&type=style&index=0&id=0770c67b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0770c67b",
  null
  
)

export default component.exports